import { useState, useEffect, useRef } from "react";

// data
import { HEADER_PINNED_SCROLL_Y_BREAKPOINT } from "core/SiteHeader/constants.js";

export const useInPageSearchIsHidden = () => {
    const [inPageSearchIsHidden, setInPageSearchIsHidden] = useState(false);
    const searchBarRef = useRef(null);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                // entry represents our element (e.g. searchBarRef)
                const searchBarIsAboveHeader =
                    entry.boundingClientRect.top <
                    HEADER_PINNED_SCROLL_Y_BREAKPOINT;

                // isIntersecting is true when any part of the element is visible.
                const searchBarIsAboveViewport = !entry.isIntersecting;

                // We need both conditions above to detect scrolling up and down, and fully in view.
                setInPageSearchIsHidden(
                    searchBarIsAboveHeader && searchBarIsAboveViewport
                );
            },
            // IntersectionObserver Config
            {
                root: null, // uses viewport as context
                rootMargin: `-${HEADER_PINNED_SCROLL_Y_BREAKPOINT}px 0px 0px 0px`, // Offsets the top detection by HEADER_PINNED_SCROLL_Y_BREAKPOINT pixels to account for the pinned header.
                threshold: 0 // Fires the observer as soon as any part of the element is out of view.
            }
        );

        // As long as we have an element to observe, let's observe
        if (searchBarRef.current) {
            observer.observe(searchBarRef.current);
        }

        // Cleanup, remove observer on dismount if we had one going
        return () => {
            if (searchBarRef.current) {
                observer.unobserve(searchBarRef.current);
            }
        };
    }, []);

    return { inPageSearchIsHidden, searchBarRef };
};
